// `info` — instructions or a caution; `acknowledge` keeps Next waiting for a tick.

import { MarkdownText } from '../../markdown'
import { text } from '../model'
import { Check, type StepProps } from './common'

export default function InfoStep({ ctl, handheld }: StepProps) {
  const { step, scope, ui } = ctl
  if (!step || !scope) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {step.body && <MarkdownText text={text(step.body, scope)} style={{ fontSize: handheld ? 16 : 14, lineHeight: 1.5 }} />}
      {step.acknowledge && (
        <Check checked={ui.ack} onChange={v => ctl.setUi({ ack: v })} handheld={handheld}
          label="I have read this" hook="_acknowledge" />
      )}
    </div>
  )
}
